export default __webpack_public_path__ + "static/bales-of-hay-c2e63849642a4fb269486ff9aef52bbd.jpeg";